import * as actionTypes from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* CampaignAnalytics Fetch Actions                                                                */
/*------------------------------------------------------------------------------------------------*/

export const updateCustomEventLimitRequest = (requestData) => ({
  type: actionTypes.UPDATE_CUSTOM_EVENT_LIMIT_REQUEST,
  requestData,
});

export const updateCustomEventLimitError = (error /*: string */) => ({
  type: actionTypes.UPDATE_CUSTOM_EVENT_LIMIT_ERROR,
  error,
});

export const updateCustomEventLimitResponse = (response) => ({
  type: actionTypes.UPDATE_CUSTOM_EVENT_LIMIT_RESPONSE,
  response,
});

export const fetchProjectLimitDataRequest = (requestData) => ({
  type: actionTypes.FETCH_PROJECT_LIMIT_DATA_REQUEST,
  requestData,
});

export const fetchProjectLimitDataError = (error /*: string */) => ({
  type: actionTypes.FETCH_PROJECT_LIMIT_DATA_ERROR,
  error,
});

export const fetchProjectLimitDataResponse = (response) => ({
  type: actionTypes.FETCH_PROJECT_LIMIT_DATA_RESPONSE,
  response,
});
